import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/dynamic-url-link-button-v1/dynamic-url-link-button-v1-index'

@Injectable({
    providedIn: 'root'
  })
export class DynamicUrlLinkButtonV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'dynamic-url-link-button-v1';
    menuTitle: string = "Dynamic Link Button";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns DynamicUrlLinkButtonV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.DynamicUrlLinkButtonV1Field(this.type, field);
        // }
        // else {
        return new fields.SettingsDynamicUrlLinkButtonV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsDynamicUrlLinkButtonV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        //return new fields.SettingsDynamicUrlLinkButtonV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    
        const f = new fields.SettingsDynamicUrlLinkButtonV1Field(field.type, field.position);
        return f.deserialize(field);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsDynamicUrlLinkButtonV1FieldComponent> {
        return fieldComponents.SettingsDynamicUrlLinkButtonV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillDynamicUrlLinkButtonV1FieldComponent> {
        return fieldComponents.FillDynamicUrlLinkButtonV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewDynamicUrlLinkButtonV1FieldComponent>{ 
        return fieldComponents.ViewDynamicUrlLinkButtonV1FieldComponent;
    }


}